import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { MatPaginator, PageEvent } from '@angular/material/paginator';

@Component({
  selector: 'app-paginator',
  templateUrl: './paginator.component.html',
  styleUrls: ['./paginator.component.scss']
})
export class PaginatorComponent implements OnInit {

  @Input() reload = false;
  @Input() itemCount = 0;
  @Input() pageSize = 50;
  @Input() pageIndex = 0;
  @Input() pageSizeOptions = [50, 100, 200, 500];
  @Output() pageEvent: EventEmitter<any> = new EventEmitter<any>();
  @ViewChild(MatPaginator) paginator!: MatPaginator;

  constructor() { }

  ngOnInit(): void {
  }

  pageEventHandler(event: PageEvent): void {
    this.pageEvent.emit(event);
  }

  resetFirstPage() {
    this.paginator.firstPage();
  }
}
